import { Type } from 'class-transformer';
import { BasketItemModel } from '.';

export class BasketInfoModel {
    public code: string;
    public guid: string;

    @Type(() => BasketItemModel)
    public entries: BasketItemModel[] = [];
}